import React from 'react'
import {FaWindowClose} from 'react-icons/fa'
import {
    PopContainer,
    PopInner,
    CloseButton,
    popContainerVariants,
    popInnerVariants
} from './PopUpElements'


const PopUp = ({children, handleClose}) => {

    const handleClick = () => {
        handleClose()
    }

    return(
        <PopContainer 
            variants={popContainerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            <PopInner
                variants={popInnerVariants}
            >
               {children}
                <CloseButton onClick={handleClick}>
                    <FaWindowClose />
                </CloseButton>
            </PopInner>
        </PopContainer>
    )
}

export default PopUp